export interface HandsFreePauseActions {
  pauseRecording: () => void;
  stopListening: (force?: boolean) => Promise<void>;
  setIsUserPaused: (value: boolean) => void;
  stopAudioPlayback: () => void;
  resetAudioRecord: () => void;
  hidePopup: () => void;
}

export function runHandsFreePause(
  isCurrentlyPaused: boolean,
  actions: HandsFreePauseActions
): boolean {
  if (isCurrentlyPaused) {
    return false;
  }

  actions.pauseRecording();
  void actions.stopListening();
  actions.setIsUserPaused(true);
  actions.stopAudioPlayback();
  actions.resetAudioRecord();
  actions.hidePopup();

  return true;
}
